import { c as _c } from "react/compiler-runtime";
import { AlertCircle, CheckCircle2, Clock, Loader2, Upload } from 'lucide-react';
import type { ImportQueueStatus } from '../types/import-queue-status';
interface ImportStatusIndicatorProps {
  status: ImportQueueStatus;
}
export function ImportStatusIndicator(t0) {
  const $ = _c(6);
  const {
    status
  } = t0;
  switch (status) {
    case "queued":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Clock className="text-muted-foreground h-3.5 w-3.5 shrink-0" aria-hidden={true} />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "preparing":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Loader2 className="text-primary h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden={true} />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "uploading":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <span className="text-primary inline-flex shrink-0 items-center gap-0.5"><Upload className="h-3 w-3" aria-hidden={true} /><Loader2 className="h-3 w-3 animate-spin" aria-hidden={true} /></span>;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "processing":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Loader2 className="text-primary h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden={true} />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "done":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CheckCircle2 className="text-primary h-3.5 w-3.5 shrink-0" aria-hidden={true} />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "failed":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <AlertCircle className="text-destructive h-3.5 w-3.5 shrink-0" aria-hidden={true} />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}